<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'Boolean'" [ngTemplateOutlet]="booleanTemplate"></ng-container>
  <ng-container *ngSwitchDefault [ngTemplateOutlet]="collapsableTemplate"></ng-container>
</ng-container>

<ng-template #booleanTemplate>
  <div *ngIf="facet.values[0] as value" class="py-4 facet">
    <py-checkbox [showLabel]="true">
      <input
        type="checkbox"
        [id]="value.code | randomId"
        [checked]="value.selected"
        (change)="handleChange(value.query.query.value)"
      />
      <span slot="label" class="w-100 h6 filter-label-wrapper" [class.py-color-grey]="value.count === 0">
        {{ facet.name }} ({{ value.count | cxNumeric: '1.0-0' }})
      </span>
    </py-checkbox>
  </div>
</ng-template>

<ng-template #collapsableTemplate>
  <div class="facet py-7">
    <button
      class="facet-button h5"
      aria-controls="collapse-facet"
      (click)="isCollapsed = !isCollapsed; setShowAll(false)"
      [attr.aria-expanded]="!isCollapsed"
    >
      {{ facet.name }} ({{ facet.values.length | cxNumeric: '1.0-0' }})
      <i nz-icon nzType="{{ isCollapsed ? 'down' : 'up' }}" nzTheme="outline"></i>
    </button>
    <div [ngClass]="facet.values.length > 5 ? 'pt-4' : 'pt-5'" id="collapse-facet" [ngbCollapse]="isCollapsed">
      <div class="pb-5" *ngIf="facet.values.length > 5">
        <div
          class="form-control p-0 d-flex align-items-center justify-content-between input-type-effects-text input-group-wrapper"
        >
          <!-- ESVCX-6753: Tab index is set to -1 to avoid autofocus on first input in drawer view -->
          <input
            type="text"
            class="border-0 w-100 h-100 pl-3"
            [size]="24"
            [id]="'' | randomId"
            [(ngModel)]="searchValue"
            [attr.aria-label]="'common.search_heading' | cxTranslate"
            [placeholder]="'catalog.search_action_placeholder' | cxTranslate"
            [tabIndex]="displayedInDrawer ? -1 : 0"
            (keyup)="handleSearch($event)"
          />

          <button
            *ngIf="!!searchValue"
            type="button"
            class="btn-icon resettable-button"
            [attr.aria-label]="'common.reset_action' | cxTranslate"
            (click)="onResetSearchInput()"
          >
            <i nz-icon class="input-icon" nzType="close-circle"></i>
          </button>
        </div>
      </div>
      <div *ngFor="let value of displayedValues" class="facet-item py-2">
        <py-checkbox [showLabel]="true">
          <input
            type="checkbox"
            [id]="value.code | randomId"
            [checked]="value.selected"
            (change)="handleChange(value.query.query.value)"
          />
          <span slot="label" class="h6 filter-label-wrapper" [class.py-color-grey]="value.count === 0">
            {{ value.name }} ({{ value.count | cxNumeric: '1.0-0' }})
          </span>
        </py-checkbox>
      </div>
      <div class="d-flex justify-content-start">
        <a *ngIf="facet.values.length > 5 && !showAll" class="load-more-link pt-4 pb-0" (click)="setShowAll(true)">
          {{ 'common.showMore_action' | cxTranslate }}
        </a>
      </div>
    </div>
  </div>
</ng-template>
